import { defineComponent } from 'vue';

var script = defineComponent({
    name: 'TransitionFadeInDelay',
});

export { script as default };
